import { render } from "./ScrollTop.vue?vue&type=template&id=2bfa6655&scoped=true"
import script from "./ScrollTop.vue?vue&type=script&lang=js"
export * from "./ScrollTop.vue?vue&type=script&lang=js"

import "./ScrollTop.vue?vue&type=style&index=0&id=2bfa6655&lang=scss&scoped=true"

import exportComponent from "/Users/songlian/Developer/官網/配音工會/taipei-sound-recording/web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bfa6655"]])

export default __exports__